
// region JS Imports

// region External Modules
import $ from "jquery"

import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory as PeriodComparisonSelectMenuFactory,
  PeriodComparisonSelectMenu,
} from "./period_comparison/index"

import {
  Factory as EconomicIndicatorComparisonSelectMenuFactory,
  EconomicIndicatorComparisonSelectMenu,
} from "./economic_indicator_comparison/index"
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope: string
}

interface InputSelector {
  scope?: string
}

const DEFAULT_SELECTOR = {
  scope: ".page--building-level-real-estate-transactions-page--compare-section-desktop",
}


class CompareSection extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery

  protected period_comparison_select_menu:             PeriodComparisonSelectMenu
  protected economic_indicator_comparison_select_menu: EconomicIndicatorComparisonSelectMenu

  protected compare_option: string | null


  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$scope = $(this.selector.scope)

    this.period_comparison_select_menu              = PeriodComparisonSelectMenuFactory.instance()
    this.economic_indicator_comparison_select_menu  = EconomicIndicatorComparisonSelectMenuFactory.instance()

    this.compare_option = "period"

    this.bind_action()
  }

  protected bind_action() {
    this.period_comparison_select_menu.on("val_change", () => {
      this.economic_indicator_comparison_select_menu.reset()

      this.compare_option = this.period_comparison_select_menu.selected_value()

      this.emit("val_change")
    })

    this.economic_indicator_comparison_select_menu.on("val_change", () => {
      this.period_comparison_select_menu.reset()

      this.compare_option = this.economic_indicator_comparison_select_menu.selected_value()

      this.emit("val_change")
    })
  }

  public selected_compare_option() {
    return this.compare_option
  }

  public is_period_comparison_selected() {
    return this.period_comparison_select_menu.is_selected()
  }

  public set_availability_of_period_comparison(filter_option: string) {
    this.period_comparison_select_menu.set_availability(filter_option)
    this.compare_option = this.period_comparison_select_menu.selected_value()
  }

  public show_comparison() {
    return this.period_comparison_select_menu.is_selected() || this.economic_indicator_comparison_select_menu.is_selected()
  }

  public set_period_comparison_option_text(button_option_text: string, selected_period_text: string) {
    this.period_comparison_select_menu.set_option_text(button_option_text, selected_period_text)
    this.period_comparison_select_menu.update_button_text()
  }

}

const Factory = {
  _instance: null as null | CompareSection,

  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new CompareSection(selector)
  },
}

export {
  Factory,
  CompareSection,
}
